import React from 'react';
import styled from 'styled-components';
import MainSplash from './MainSplash';
import SubSplash from './SubSplash';
import { Col } from 'reactstrap';
import ServiceRow from './ServiceRow';
import ReviewCarousel from './ReviewCarousel';

const ContentContainer = styled.div`
    padding: 2em;
    @media (min-width: 770px) {
        padding: 8em;
    }
    @media (min-width: 1400px) {
        padding: 4em 13em 4em 13em;
    }
`;

const Header = styled.h2`
    text-align: center;
    font-family: Lato-Bold;
    font-size: 1.6rem;
    color: var(--main-teal-color);
    padding-bottom: 1em;
    &:not(:first-child) {
        margin-top: 3em;
    }
`;
const SubHeader = styled.h3`
    text-align: center;
    font-family: Lato-Regular;
    font-size: 1.2rem;
    color: var(--main-grey-color);
    padding-bottom: 1em;
`;

const InformationRow = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;

function Home() {
    return (
        <div style={{ position: 'relative' }}>
            <MainSplash />
            <ContentContainer>
                <div>
                    <Header>Affordable motorhome hire for NHS staff</Header>
                    <InformationRow>
                        <Col md={5}>
                            <p style={{ fontSize: '1rem' }}>
                                Spacious, comfortable and perfect for families.
                                Enjoy your holiday your way, from the seaside to
                                the mountains, or the city to the countryside -
                                the choice is yours.
                            </p>
                        </Col>
                        <Col md={5}>
                            <p style={{ fontSize: '1rem' }}>
                                Our state-of-the-art motorhomes offer
                                comfortable dining areas and sleep up to 4
                                people (2 adults and 2 children). They include
                                powerful engines and automatic gearboxes for
                                convenience.
                            </p>
                        </Col>
                    </InformationRow>
                </div>
                <Header>Convenient, hassle-free service</Header>
                <SubHeader>
                    All inclusive; gas, bedding, cutlery and crockery included
                    as standard. Just add fuel.
                </SubHeader>
                <ServiceRow />
                <SubSplash />
                <Header>Read the reviews</Header>
                <ReviewCarousel />
            </ContentContainer>
        </div>
    );
}
export default Home;
